import { useEffect, useState } from 'react';

/**
 * Значение с задержкой: обновляется, когда ввод затих на `delay` миллисекунд.
 *
 * Нужно там, где на каждое изменение уходит запрос. Поиск в шапке кабинета
 * меняется на каждой букве, и без задержки «карбонара» — это девять запросов,
 * из которых восемь устарели ещё до ответа.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
